import GlobalHeader from './globalHeader';
import OrganisationHeader from './organisationHeader';

const HeaderView = () => (
  <header>
    <GlobalHeader/>
    <OrganisationHeader/>
  </header>
);

export default HeaderView;
